import React, { useMemo, useState } from "react";
import useCompanySettings from "hooks/useCompanySettings";
import companySettings from "validations/companySettings";
import BrandingSettings from "components/admin/settings/CompanySettings/BrandingSettings";

/**
 * Branding as its own route (OUT-1379). It was a tab inside Company Settings,
 * which is why the card image had nowhere to live: it is branding, but it sat
 * on the company page because that is where the branding tab happened to be.
 */
const Branding: React.FC = () => {
  const [openBrandPresetsDrawer, setOpenBrandPresetsDrawer] = useState(false);

  // Same gate the tab action carried before branding became a route.
  const shouldDisplaySavedScheme = useMemo(() => {
    const env = process.env.REACT_APP_SENTRY_ENV;
    return env === "development" || env === "stage";
  }, []);

  const {
    companyProfile,
    logos,
    customColors,
    handleUpdateCustomColors,
    uploadLogo,
    handleRemoveLogo,
    specificUploadingStates,
  } = useCompanySettings({ formikValidation: companySettings });

  return (
    <BrandingSettings
      logos={logos}
      companyDetails={companyProfile?.values}
      uploadLogo={uploadLogo}
      handleRemoveLogo={handleRemoveLogo}
      uploading={specificUploadingStates.branding}
      handleUpdateCustomColors={handleUpdateCustomColors}
      customColors={customColors}
      showBrandPresets={shouldDisplaySavedScheme}
      openBrandPresetsDrawer={openBrandPresetsDrawer}
      setOpenBrandPresetsDrawer={setOpenBrandPresetsDrawer}
    />
  );
};

export default Branding;
